import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogComponent } from 'app/componentes/mat-dialog/mat-dialog.component';
import { AvisosService } from 'app/services/vinculacion/avisos/avisos.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-avisos-contenido',
  templateUrl: './avisos-contenido.component.html',
  styleUrls: ['./avisos-contenido.component.scss']
})
export class AvisosContenidoComponent implements OnInit {


  AvisoForm = new FormGroup({
    contenido: new FormControl('', [Validators.required])
  });
  
  constructor(private servicioavisos: AvisosService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    ) { }

  ngOnInit(): void {
    this.obtenerDatos()
  }


  //VERIFICAMOS SI EL USUARIO VA A SALIR DE LA RUTA  CON DATOS EN EL FORMULARIO
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.AvisoForm.dirty) {
      const dialogRef = this.dialog.open(MatDialogComponent, {
        data: {
          message: ' ¿ Desea salir sin guardar los cambios ? ',
          buttonText: {
            ok: 'Aceptar',
            cancel: 'Cancelar'
          }
        }
      });
      return dialogRef.afterClosed();
    } else {
      return true;
    }

  }

  //AVISO TIPO SNACKBAR ANGULAR MATERIAL
  openSnackBar(message: string) {
    this.snackBar.open(message, "Aceptar", { duration: 2000 });
  }

  onChangeEvent($event) {

  }

  obtenerDatos = () => {
    this.servicioavisos.getAvisoContenido(1).subscribe(response => {
      // this.ckeditorContent = response[0].AvisoForm;
      this.AvisoForm.patchValue(response[0]);
      this.AvisoForm.markAsPristine()
      this.AvisoForm.markAllAsTouched()
    })
  }


  guardarDatos = () => {

    this.servicioavisos.actualizarAvisoContenido(1, this.AvisoForm.value).subscribe(response => {
      this.AvisoForm.markAsPristine()
      this.AvisoForm.markAllAsTouched()
      this.openSnackBar('REGISTRO ACTUALIZADO!');
      this.ngOnInit()
    })

  }

}
